import React, { useState, useRef, useCallback } from "react";
import "../DistrictSelectModal.css";
import { useDispatch, useSelector } from "react-redux";
import { MSME_CITY } from "../utils/Constants";
import * as authActions from "../store/action/auth";
import * as cartActions from "../store/action/cart";
import { useLocation, useNavigate } from "react-router-dom";
import { storeCookie } from "../utils/CookieAction";

const DistrictSelectModal = ({ isOpen, onSelect, showClose, setModalOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { storeCity } = useSelector((state) => state.auth);
  const { districtList } = useSelector((state) => state.menu);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtSearch, setDistrictSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const url = location?.pathname;
  const parts = url.split("/");
  const lastValue = parts.pop();

  const decodedValue = url.includes("search-product")
    ? lastValue
    : btoa("search");

  const handleSelect = useCallback((district) => {
    if (district === "All") {
      setSelectedDistrict(district);
      setShowDropdown(false);
      setDistrictSearch(district);
      storeCookie(MSME_CITY, "");
      return false;
    }

    setSelectedDistrict(district.name);
    setShowDropdown(false);
    setDistrictSearch(district.name);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedDistrict === "All") {
      await dispatch(cartActions.cartClean());
      storeCookie(MSME_CITY, "");
      dispatch(authActions.storeCity(""));
      navigate("/");
      setModalOpen(false);
      return false;
    }

    if (storeCity !== selectedDistrict) {
      await dispatch(cartActions.cartClean());
    }

    if (selectedDistrict) {
      storeCookie(MSME_CITY, selectedDistrict);
      dispatch(authActions.storeCity(selectedDistrict));

      (location?.pathname === "/" ||
        location?.pathname.includes("about") ||
        location?.pathname.includes("buyer") ||
        location?.pathname.includes("seller") ||
        location?.pathname.includes("marketing") ||
        location?.pathname.includes("contact") ||
        location?.pathname.includes("search-product") ||
        location?.pathname.includes("verified-seller")) &&
        navigate(`/search-product/${selectedDistrict}/${decodedValue}`);
    }

    setDistrictSearch("");
    onSelect(selectedDistrict);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div
          className={`d-flex align-items-center justify-content-between`}
          style={{
            marginBottom: 10,
            alignSelf: showClose ? "auto" : "center",
          }}
        >
          <h6 className="text-xl text-gray-800 m-0">
            🏙️ <b>Please Select a District</b>
          </h6>
          {showClose && (
            <button className="close-btn" onClick={onSelect}>
              ❌
            </button>
          )}
        </div>

        {!showClose && (
          <p className="text-gray-600" style={{ marginTop: 10 }}>
            Please select your district before proceeding with the purchase.
          </p>
        )}

        <form onSubmit={handleSubmit}>
          <div
            className="custom-dropdown"
            ref={dropdownRef}
            style={{ marginTop: 10 }}
          >
            <input
              type="text"
              placeholder="Select District..."
              value={districtSearch}
              onChange={(e) => setDistrictSearch(e.target.value)}
              onFocus={() => setShowDropdown(true)}
              className="dropdown-input"
              required
            />
            {showDropdown && (
              <ul className="dropdown-list">
                {storeCity !== "All" && storeCity !== "" && (
                  <li onClick={() => handleSelect("All")}>All District</li>
                )}

                {districtList
                  .filter((district) =>
                    district?.name
                      .toLowerCase()
                      .includes(districtSearch.toLowerCase()),
                  )
                  .map((district, index) => (
                    <li key={index} onClick={() => handleSelect(district)}>
                      {district?.name}
                    </li>
                  ))}
              </ul>
            )}
          </div>

          <button
            type="submit"
            className={`continue-btn ${selectedDistrict ? "active" : ""}`}
            disabled={!selectedDistrict}
          >
            ✅ Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default DistrictSelectModal;
